import { jsx as _jsx } from "react/jsx-runtime";
import { LazyToastContainer } from "@faire/retailer-visitor-shared/components/Toast";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import cn from "classnames";
import React, { Suspense } from "react";
import { toastTopVar } from "./consts";
export var ToastContainer = function(param) {
    var style = param.style;
    var isMobile = useViewport().isMobile;
    return /*#__PURE__*/ _jsx("div", {
        className: cn("sticky z-12 h-0", toastTopVar.className),
        style: style,
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyToastContainer, {
                position: isMobile ? "bottom-center" : "top-right",
                style: isMobile ? undefined : DESKTOP_AND_ABOVE_STYLE
            })
        })
    });
};
var DESKTOP_AND_ABOVE_STYLE = {
    position: "absolute",
    top: "initial",
    bottom: getSpacing("-3x"),
    right: getSpacing("3x"),
    left: "auto",
    width: "fit-content",
    height: "fit-content",
    padding: "0",
    zIndex: 11,
    maxWidth: "325px",
    transform: "translateY(100%)"
};
